import { useQuery } from 'react-query'

import { fetchRecurringInvoiceDraftFormat } from '@features/recurringInvoices/query-api'

import { QueryKeys } from '../../../../../enums/queryKeys'

export const useFetchRecurringInvoiceDraftFormat = (recurringInvoiceId: string) => {
  const {
    data: recurringInvoiceData,
    isLoading,
    ...rest
  } = useQuery(
    [QueryKeys.RecurringInvoiceDraftFormat, recurringInvoiceId],
    () => fetchRecurringInvoiceDraftFormat(recurringInvoiceId),
    {
      enabled: !!recurringInvoiceId,
    },
  )

  return { recurringInvoice: recurringInvoiceData?.data, isLoading, ...rest }
}
